import React, { useState } from "react";
import { Input, Alert } from "antd";
import { checkPageNameAvailability } from "../../utils/pages";
import SimpleReactValidator from "simple-react-validator";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

const WelcomeStep1 = ({ setPageName, pageName }) => {
  const [isNameAvailable, setIsNameAvailable] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  let validator = new SimpleReactValidator();

  const validatePageName = async (name) => {
    try {
      setIsNameAvailable(false);
      setPageName();
      validator.message("name", name, "alpha_num_dash|required|min:4|max:30");
      if (validator.allValid()) {
        setErrorMessage();
        let res = await checkPageNameAvailability(name);
        if (res.IsAvailable) {
          setIsNameAvailable(true);
          setPageName(name);
        } else {
          setErrorMessage("😅 Opsss, ce nom de page est déjà pris.");
          setIsNameAvailable(false);
        }
      } else {
        setErrorMessage(
          "Le champ doit faire entre 4 et 30 caractères contenant seulement des chiffres et lettres"
        );
      }
    } catch (e) {
      console.log(e);
      setErrorMessage("Une erreur s'est produite. Contactez le chat.");
    }
  };

  return (
    <div className="welcome-modal-content">
      <div className="header-modal">
        Créons votre première page Linksight ensemble{" "}
        <span role="img" aria-label="emoji">
          💫
        </span>{" "}
      </div>
      <div className="content-welcome-modal">
        <div className="form-new-page">
          <div>Quel nom voulez-vous donner à votre page ? </div>
          <small>(vous pourrez changer le nom de votre page plus tard)</small>
          <div className="input-pagename">
            <Input
              //   prefix={loading ? <LoadingOutlined /> : ""}
              suffix={
                isNameAvailable || pageName ? (
                  <CheckCircleTwoTone twoToneColor="#31D79F" />
                ) : (
                  <CloseCircleTwoTone twoToneColor="#FF808B" />
                )
              }
              onChange={(e) => {
                validatePageName(e.target.value);
                // setPageName(e.target.value);
              }}
              placeholder="xsqueezie"
              minLength={4}
              maxLength={30}
              defaultValue={pageName}
            />
            {errorMessage ? (
              <Alert type="warning" showIcon message={errorMessage} />
            ) : (
              ""
            )}
            <div className="link-display-welcome">
              Votre lien sera : <b>linksight.me/{pageName ? pageName : ""}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep1;
